function getUserClickedProperties(): Array<number> {
    let propertyIDs: Array<number> = [];

    const cachedPropertyIDs = window.appStorage.getLocalItem( 'userClickedProperties' );

    if ( cachedPropertyIDs !== null && cachedPropertyIDs.length > 0 ) {
        propertyIDs = JSON.parse( cachedPropertyIDs );
    }

    return propertyIDs;
}

function rememberPropertyClick( propertyID: number ): void {
    const propertyIDs = getUserClickedProperties();

    if ( propertyIDs.includes( propertyID ) ) {
        return;
    }

    propertyIDs.push( propertyID );

    window.appStorage.setLocalItem( 'userClickedProperties', JSON.stringify( propertyIDs ) );
}

function hasUserClickedProperty( propertyID: number ): boolean {
    const propertyIDs = getUserClickedProperties();

    if ( propertyIDs.length === 0 || !propertyIDs.includes( propertyID ) ) {
        return false;
    }

    return true;
}

function getSavedProperties() {
    let savedProperties = {};

    const savedPropertiesFromSession = window.appStorage.getSessionItem( 'savedProperties' );

    if ( savedPropertiesFromSession !== null && savedPropertiesFromSession.length > 0 ) {
        savedProperties = JSON.parse( savedPropertiesFromSession );
    }

    return savedProperties;
}

function hasUserSavedProperty( propertyID: number ): boolean {
    const savedProperties = getSavedProperties();

    if ( !savedProperties[ propertyID ] ) {
        return false;
    }

    return true;
}

function hasUserContactedProperty( propertyID: number ): boolean {
    const savedProperties = getSavedProperties();

    if ( !savedProperties[ propertyID ] ) {
        return false;
    }

    return savedProperties[ propertyID ].contacted;
}

export {
    rememberPropertyClick,
    hasUserClickedProperty,
    hasUserContactedProperty,
    hasUserSavedProperty,
    getSavedProperties,
};
